import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string");

class OcorrenciaApi {
  cancelTokens = {
    getOcorrencia: null,
    getOcorrencias: null,
    setOcorrencia: null,
    destroyOcorrencia: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async destroyOcorrencia(ocorrenciaId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.destroyOcorrencia = source;

    const { data } = await axiosInstance.delete(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${ocorrenciaId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.destroyOcorrencia = null;
    return data;
  }

  async setOcorrencia(ocorrencia) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
  
    this.cancelTokens.setOcorrencia = source;
  
    const formData = new FormData();
    formData.append("ocorrencia[titulo]", ocorrencia.titulo);
    formData.append("ocorrencia[descricao]", ocorrencia.descricao);
    formData.append("ocorrencia[tipo]", ocorrencia.tipo);
    formData.append("ocorrencia[status]", ocorrencia.status);
  
    if (ocorrencia.file) {
      formData.append("ocorrencia[anexo]", ocorrencia.file);
    }
  
    let response;
  
    if (ocorrencia.id) {
      response = await axiosInstance.put(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${ocorrencia.id}`,
        formData,
        {
          cancelToken: source.token,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
    } else {
      response = await axiosInstance.post(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias`,
        formData,
        {
          cancelToken: source.token,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
    }
  
    this.cancelTokens.setOcorrencia = null;
    return response.data;
  }
  
  async getOcorrencias({ page = 1, qtd_por_pagina, titulo, tipo, status }) {
    const query = queryString.stringify({
      page,
      qtd_por_pagina,
      titulo,
      tipo,
      status,
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getOcorrencias = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias?${query}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getOcorrencias = null;

    return data;
  }

  async getOcorrencia(ocorrenciaId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getOcorrencia = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${ocorrenciaId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getOcorrencia = null;

    return data;
  }

  async updateOcorrencia(id, statusPayload) {
    const payload = {
      ocorrencia: statusPayload
    };
  
    const { data } = await axiosInstance.put(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${id}`,
      payload,
      { cancelToken: axios.CancelToken.source().token }
    );
  
    return data;
  }
  
  async getComentarios(ocorrenciaId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
  
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${ocorrenciaId}/comentarios`,
      {
        cancelToken: source.token,
      }
    );
  
    return data;
  }
  

}

export default OcorrenciaApi;
